<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="450px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="名称" align="center"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip label="费用" align="center"
                             prop="fee"></el-table-column>
            <el-table-column show-overflow-tooltip label="图片" align="center"
                             prop="happenDate">
              <template slot-scope="scope">
                <div v-if="scope.row.imageUrls">
                  <img @click="openImageDialog(item)" v-for="(item, index) in scope.row.imageUrls.split(',')" :key="index" :src="item" style="width: 50px;height: 50px;cursor: pointer;" >
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="录入人" align="center"
                             prop="createName"></el-table-column>
            <el-table-column show-overflow-tooltip label="费用日期" align="center"
                             prop="happenDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="210" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="feeDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增明细' : '编辑明细'" append-to-body>
      <el-form ref="feeForm" label-position="right" label-width="120px" :model="feeDialog.formData"
               :rules="rules">
        <el-form-item label="费用项目：" prop="itemId">
          <el-select filterable  v-model="feeDialog.formData.itemId" placeholder="请选择费用项目" clearable style="width: 100%;">
            <el-option v-for="item in items" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用：" prop="fee">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="feeDialog.formData.fee"
                           clearable/>
        </el-form-item>
        <el-form-item label="图片：">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="录入人：" prop="createId">
          <el-select filterable  v-model="feeDialog.formData.createId" placeholder="请选择录入人" clearable style="width: 100%;">
            <el-option v-for="item in persons" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="feeDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="feeDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="imageDialog.visible" :close-on-click-modal="false" append-to-body width="40%"
               title="查看图片">
      <div style="display: flex;justify-content: center;align-items: center;">
        <img :src="imageDialog.url" style="width: 50%;height: 50%;">
      </div>
      <div class="dialog-btn">
        <el-button type="primary" @click="download(imageDialog.url)">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData, getList} from "@/api/fee";
import {getAll as getPersons} from "@/api/user";

export default {
  props: {
    houseId: {
      type: Number,
      default: 0
    },
    houseName: {
      type: String,
      default: ''
    }
  },
  watch: {
    houseId(newVal) {
      this.initParams()
      this.search(true)
    }
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          type: 0,
          houseId: ''
        },
        total: 0,
        data: []
      },
      feeDialog: {
        formData: {
          houseId: '',
          houseName: '',
          rentRecordIds: '',
          rentRecordNames: '',
          name: '',
          itemId: '',
          fee: 0,
          type: 0,
          description: '',
          imageUrls: '',
          createId: '',
          createName: '',
          sort: 0
        },
        visible: false
      },
      rules: {
        itemId: [
          {trigger: 'blur', required: true, message: '请选择费用项目'}
        ],
        fee: [
          {trigger: 'blur', required: true, message: '请输入费用'}
        ],
        sort: [
          {trigger: 'blur', required: true, message: '请输入排序值'}
        ],
        createId: [
          {trigger: 'blur', required: true, message: '请选择录入人'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      rentRecordIds: [],
      title: '',
      items: [],
      type: 0,
      fileList: [],
      imageDialog: {
        visible: false,
        url: ''
      },
      persons: []
    }
  },
  mounted() {
    this.initParams()
    this.search(true)
    this.getItems()
    this.getPersons()
  },
  methods: {
    getPersons() {
      getPersons().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.persons = response.data.filter(item => item.roleIds == 2)
        }
      })
    },
    getItems() {
      const params = {
        type: 4
      }
      getList(params).then(response => {
        if (response.code == 200) {
          this.items = response.data
        }
      })
    },
    initParams() {
      this.table.query.type = this.type
      this.table.query.houseId = this.houseId
      this.feeDialog.formData.type = this.type
      this.feeDialog.formData.houseId = this.houseId
      this.feeDialog.formData.houseName = this.houseName
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
        this.table.query.type = this.type
        this.table.query.houseId = this.houseId
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        type: this.table.query.type,
        houseId: this.table.query.houseId
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改
    saveOrUpdateData() {
      this.loading = true
      this.$refs['feeForm'].validate(async (valid) => {
        if (valid) {
          this.feeDialog.formData.name = this.items.filter(item => item.id == this.feeDialog.formData.itemId)[0].name
          this.feeDialog.formData.createName = this.persons.filter(item => item.id == this.feeDialog.formData.createId)[0].nickname
          saveOrUpdateData(this.feeDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.feeDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      this.fileList = []
      if (!isEdit) {
        // 重置数据
        this.feeDialog.formData = {
          houseId: this.houseId,
          houseName: this.houseName,
          rentRecordIds: '',
          rentRecordNames: '',
          feeIds: '',
          feeNames: '',
          fee: 0,
          name: '',
          agencyFee: 0,
          type: this.type,
          description: '',
          imageUrls: '',
          sort: 0
        }
      } else {
        if (data.imageUrls) {
          const imageUrls = data.imageUrls.split(',')
          for (let i = 0; i < imageUrls.length; i++) {
            this.fileList.push({
              uid: i,
              url: imageUrls[i]
            })
          }
        }
        this.feeDialog.formData = JSON.parse(JSON.stringify(data))
      }
      this.feeDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.feeForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除
    deleteData(id) {
      this.$confirm('此操作将永久删除' + this.title + '信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSuccess(response, file) {
      this.fileList.push({
        uid: file.uid,
        url: response.url
      })
      this.feeDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.url != file.url)
      if (this.fileList && this.fileList.length > 0) {
        this.feeDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
      } else {
        this.feeDialog.formData.imageUrls = ''
      }
    },
    openImageDialog(url) {
      this.imageDialog.url = url
      this.imageDialog.visible = true
    },
    download(url) {
      window.open(url);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/FeeItem.vue